import { render } from "./ErrorPanel.vue?vue&type=template&id=a7b06066&scoped=true"
import script from "./ErrorPanel.vue?vue&type=script&lang=js"
export * from "./ErrorPanel.vue?vue&type=script&lang=js"

import "./ErrorPanel.vue?vue&type=style&index=0&id=a7b06066&scoped=true&lang=less"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b06066"]])

export default __exports__